import type { ButtonHTMLAttributes } from 'react';
import clsx from 'clsx';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'sm' | 'md';
}

export function Button({
  variant = 'primary',
  size = 'md',
  className,
  disabled,
  children,
  ...props
}: ButtonProps) {
  return (
    <button
      className={clsx(
        'inline-flex items-center justify-center gap-1.5 rounded font-medium leading-none transition-colors whitespace-nowrap align-middle',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        size === 'sm' && 'h-8 px-2.5 text-xs',
        size === 'md' && 'h-9 px-3.5 text-sm',
        variant === 'primary' &&
          'bg-accent text-surface hover:bg-accent-hover',
        variant === 'secondary' &&
          'bg-surface-lighter text-text hover:bg-surface-light',
        variant === 'ghost' &&
          'bg-transparent text-text-muted hover:bg-surface-lighter hover:text-text',
        className
      )}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}
